import TableCol from "@rio-cloud/rio-uikit/TableCol";
import TableHead from "@rio-cloud/rio-uikit/TableHead";
import useSorting from "@rio-cloud/rio-uikit/useSorting";
import type {
  ExtractData,
  InfractionData,
  EventType,
} from "./types/types";
import { datetimeFormatter, formatCoordinates } from "../../shared/utils";
import { Dialog, SortDirection } from "@rio-cloud/rio-uikit";
import MapEvents from "../../shared/components/Maps";
import { useState } from "react";
import { useSelectVehicleStore } from "../../services/selectVehicleSlice";

type ColumnLabel = { [key: string]: string };

const columnLabels: ColumnLabel = {
  datetimeUtc: "Data/Hora",
  latitude: "Localização",
  infractionType: "Evento",
};

type ExtractEventsTableProps = {
  events: ExtractData["events"];
};

export function ExtractEventsTable({ events }: ExtractEventsTableProps) {

  const [showDialog, setShowDialog] = useState(false);
  const [map, setMap] = useState({lat: 0, lng: 0});
  const { selectedVehicle } = useSelectVehicleStore();

  const goodPractices = ['IT_OVERNIGHT', 'IT_TRIP_HOURS', 'IT_DAY_HOURS']

  const { sortedItems, sortKey, sortDirection, setSortKey, toggleDirection } =
    useSorting(events, "datetimeUtc", SortDirection.DESCENDING);

  const handleSortChange = (event: React.MouseEvent<HTMLTableCellElement>) => {
    const newSortBy = event.currentTarget.getAttribute("data-sortby");
    if (newSortBy) {
      setSortKey(newSortBy as keyof InfractionData);
    }
    if (newSortBy === sortKey) {
      toggleDirection();
    }
  };

  return (
    <div className="overflow-x-auto panel panel-default padding-0 panel-body margin-bottom-0 ">
      <table className="table table-column-overflow-hidden table-bordered table-sticky table-head-filled">
        <colgroup>
          {Object.keys(columnLabels).map((column) => (
            <TableCol key={column} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {Object.keys(columnLabels).map((column) => (
              <TableHead
                key={column}
                label={columnLabels[column]}
                column={column}
                sortBy={sortKey as string}
                sortDir={sortDirection}
                onClick={handleSortChange}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedItems.map((event) => {

            let coordinates: string = "N/A";
            if (event.latitude && event.longitude) {
              coordinates = formatCoordinates(event.latitude, event.longitude);
            }
            return (
              <tr key={event.id} data-id={event.id} className={goodPractices.includes(event.type) ? "success" : "warning"}>
                <td className="white-space-nowrap">
                  {datetimeFormatter.format(new Date(event.datetimeUtc))}
                </td>
                <td className="white-space-nowrap">
                  <button className='btn' style={{ backgroundColor: 'transparent' }} onClick={() => {
                    if(event.latitude && event.longitude){
                      setMap({lat: Number(event.latitude), lng: Number(event.longitude)})
                      setShowDialog(true);
                    }
                  }}>
                    <span className="rioglyph rioglyph-map-marker rioglyph-align-baseline text-size-16" />{" "}
                    {coordinates}
                  </button>
                </td>
                <td className="white-space-nowrap">
                  <div className="display-flex flex-wrap gap-10">
                    <div className={goodPractices.includes(event.type) ? 'label label-success' : 'label label-warning'}>
                      {EventMap.get(event.type) ??
                        "Outro tipo de infração"}
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Dialog
        show={showDialog}
        body={<MapEvents lat={map.lat} lng={map.lng} />}
        title={`Localização do Evento - ${selectedVehicle.name}`}
        onClose={() => {
          setShowDialog(false);
        }}
        showCloseButton
        bsSize='md'
      />
    </div>
  );
}

const EventMap = new Map<EventType, string>([
  ["IT_SPEED", "Excesso de Velocidade"],
  ["IT_BRAKING", "Frenagem Brusca"],
  ["IT_COASTING", "Aproveitamento de Inércia"],
  ["IT_KICKDOWN", "Aceleração"],
  ["IT_ACCELERATION", "Partida"],
  ["IT_RPM", "Rotação do Motor"],
  ["IT_CLUTCH", "Uso da Embreagem"],
  ["IT_OPERATIONAL_INSISTENCE", "Insistência Operacional"],
  ["IT_IDLING", "Marcha Lenta"],
  ["IT_IDLING_AC", "Climatização evitada com veículo parado"],
  ["IT_ATTENTIVE_DRIVING", "Condução"],
  ["IT_ROLLOVER", "Condição de Estabilidade"],
  ["IT_OVERNIGHT", "Pernoite com tanque cheio"],
  ["IT_TRIP_HOURS", "Duração da Viagem"],
  ["IT_DAY_HOURS", "Jornada Diária"]
]);
